var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AvatarComponent',{attrs:{"color":_vm.color,"text":_vm.initialsForName,"tooltip":_vm.name,"size":_vm.size,"square":true}})}
var staticRenderFns = []

export { render, staticRenderFns }